/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portions_MoreInputs */

const en_portions_more = /** @type {(inputs: Portions_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More portions`)
};

const de_portions_more = /** @type {(inputs: Portions_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr Portionen`)
};

/**
* | output |
* | --- |
* | "More portions" |
*
* @param {Portions_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const portions_more = /** @type {((inputs?: Portions_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portions_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portions_more(inputs)
	return en_portions_more(inputs)
});